@if (!isModal) {
  <div class="container-generic">
    <app-menu [menuModuleEnum]='menuModuleEnum'></app-menu>
    <div class="container-body">
      <ng-container *ngTemplateOutlet="medicamentosTemplate"></ng-container>
    </div>
  </div>
}

@if (isModal) {
  <div mat-dialog-content>
    <div class="mat-dialog-header">
      <div class="mat-dialog-content">
        <ng-container *ngTemplateOutlet="medicamentosTemplate"></ng-container>
      </div>
    </div>
  </div>
}

<ng-template #medicamentosTemplate>
  <div style="display: flex; flex-direction: row; justify-content: space-between;">
    @if (!isModal) {
      <h1>Tabela de medicamentos ativos e materiais</h1>
    }
    @if (isModal) {
      <h2><strong>Tabela de medicamentos ativos e materiais</strong></h2>
    }
    @if (!isModal) {
      <div class="col-md-2">
        <button mat-flat-button type="button" (click)="getListNoPaginated();" color="primary" class="btn-block" [disabled]="!listActiveMedicationStockStruct || listActiveMedicationStockStruct.length == 0">
          @if (isPrintTableLoading == false) {
            <span>Imprimir tabela</span>
          }
          @if (isPrintTableLoading == true) {
            <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
          }
        </button>
      </div>
    }
  </div>
  @if (isFirstLoading) {
    <app-loading-progress-bar></app-loading-progress-bar>
  }
  <div class="white-body">
    <div class="filters">
      <div class="row">
        <div class="col-12 col-sm-6 col-md-3">
          <mat-form-field appearance="outline">
            <mat-icon matPrefix class="my-icon">search</mat-icon>
            <mat-label>Pesquisar</mat-label>
            <input matInput type="text" id="searchText" name="searchText" [(ngModel)]="searchText"
              (keyup)="onKeySearch($event)">
            </mat-form-field>
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <mat-form-field appearance="outline">
              <mat-label>Filtrar por Medicamentos/Materiais</mat-label>
              <mat-select (selectionChange)="search()" [(ngModel)]="productType">
                <mat-option [value]="pharmacyProductTypeEnum.Todos">Todos</mat-option>
                <mat-option [value]="pharmacyProductTypeEnum.Medicamento">Medicamento</mat-option>
                <mat-option [value]="pharmacyProductTypeEnum.MedicamentoControlado">Medicamento Controlado</mat-option>
                <mat-option [value]="pharmacyProductTypeEnum.Item">Material</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          @if (productType != pharmacyProductTypeEnum.Item) {
            <div class="col-12 col-sm-6 col-md-3">
              <mat-form-field appearance="outline">
                <mat-label>Grupo de Medicamento</mat-label>
                <mat-select (selectionChange)="search()" [multiple]="true" [(ngModel)]="listIdMedicineGroup">
                  @for (item of listGroupStruct; track item) {
                    <mat-option
                      [value]="item.medicineGroup.idMedicineGroup">
                    {{item.medicineGroup.medicineGroupName}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
          @if (productType != pharmacyProductTypeEnum.Item) {
            <div class="col-12 col-sm-6 col-md-3">
              <mat-form-field appearance="outline">
                <mat-label>Subgrupo de Medicamento</mat-label>
                <mat-select (selectionChange)="search()" [multiple]="true" [(ngModel)]="listIdMedicineSubGroup">
                  @for (item of listSubgroupStruct; track item) {
                    <mat-option
                      [value]="item.medicineSubgroup.idMedicineSubgroup">
                    {{item.medicineSubgroup.medicineSubgroupName}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
        </div>
      </div>
      <div class="total-values">
        <span><b>Total em estoque: </b>{{totalStock}}</span>
        <span><b>Total R$ em estoque: </b>{{totalValueInStock}}</span>
      </div>
      <div class="table-padding">
        <app-table [columns]="columns" [list]="listActiveMedicationStockStruct"></app-table>
      </div>
      @if ((!listActiveMedicationStockStruct || listActiveMedicationStockStruct.length == 0) && !isLoading) {
        <app-empty-list
        ></app-empty-list>
      }
      @if (isLoading) {
        <app-loading-list></app-loading-list>
      }
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12">
          <mat-paginator [length]="fullSize" #paginator [pageIndex]="pageIndex" [pageSize]="pageSize"
            aria-label="Select page" (page)="changePage($event.pageIndex)" [hidePageSize]="true">
          </mat-paginator>
        </div>
      </div>
      <div class="row">
        <div class="col-2">
          @if (!isModal) {
            <a routerLink="/pharmacy/movement" mat-flat-button color="accent" class="btn-block">
              <span>Voltar</span>
            </a>
          }
          @if (isModal) {
            <a (click)="closeDialog();" mat-flat-button color="accent" class="btn-block">
              <span>Voltar</span>
            </a>
          }
        </div>
      </div>
    </div>
  </ng-template>